<template>
  <div class="page flex-col">

    <div class="section_2 flex-row">
      <div class="text-group_1 flex-col justify-between">
        <span class="text_2">Hi~&nbsp;&nbsp;{{ userInfo.username || '用户' }}</span>
        <span class="text_3">积分：{{ userInfo.balance || 0 }}</span>
      </div>
      <div class="kefu_area" v-if="showKefu" @click="contactKefu">
        <span class="text_4">客服</span>
        <img
          class="kefu_icon"
          referrerpolicy="no-referrer"
          src="./assets/img/Frame.png"
        />
      </div>
    </div>
    <div class="section_3 flex-row">
      <img
        class="banner-signin"
        src="./assets/img/Group_325@2x.png"
        alt="到点自动签到/自定义签到位置"
      />
    </div>
    <div class="section_4 flex-row" v-if="showKefuNotice">
      <div class="image-text_1 flex-row justify-between">
        <img
          class="label_1"
          referrerpolicy="no-referrer"
          src="./assets/img/FigmaDDSSlicePNG6ff75895e7d672ba47f37826323cbb43.png"
        />
        <span class="text-group_2">{{ kefuText }}</span>
      </div>
    </div>
    <div class="section_5 flex-row" style="justify-content: center;">
      <div class="text-wrapper_1 flex-col" @click="addGongXueYun">
        <span class="text_7">添加公学芸</span>
      </div>
    </div>
    <div class="added-count">
      <span class="added-count-label">总用户数</span>
      <span class="added-count-value">{{ gxyAddedCount }}</span>
      <span class="promo-red promo-red-count">39半年！</span>
    </div>
    <div class="multi-gxy-tip">
      <strong>可添加多个公学芸账号</strong>
      <span>一个网站账号可绑定多个公学芸账号，独立云手机，接的YF平台</span>
      <span class="promo-red">39半年</span>
    </div>
    <!-- 类似微信公众号消息的 AIGC 卡片 -->
    <div class="wechat-article-card" @click="openAigc">
      <!-- 上半部分：模拟公众号封面图 -->
      <div class="wac-cover">
         <div class="wac-cover-glow"></div>
         <h2 class="wac-title">
           永久免费自动排版<br>
           <span class="wac-title-gradient">各种论文</span>
         </h2>
         <p class="wac-subtitle">只需上传论文模板和论文文档，系统自动匹配格式，一键生成标准论文。</p>
         <div class="wac-features">
           <span><svg viewBox="0 0 14 14" fill="none"><path d="M2.5 7.5L5.5 10.5L11.5 3.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg> 无需注册</span>
           <span><svg viewBox="0 0 14 14" fill="none"><path d="M2.5 7.5L5.5 10.5L11.5 3.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg> 无需付费</span>
           <span><svg viewBox="0 0 14 14" fill="none"><path d="M2.5 7.5L5.5 10.5L11.5 3.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg> 自动调格式</span>
         </div>
         <div class="wac-btns">
           <div class="wac-btn-primary">开始免费排版 &rarr;</div>
           <div class="wac-btn-outline">尝试降AIGC</div>
         </div>
      </div>
      <!-- 下半部分：黑色摘要区域 -->
      <div class="wac-info">
        <h3 class="wac-info-title">AIGC 降重 / 论文智能排版</h3>
        <p class="wac-info-desc">点击免费使用 &rarr;</p>
      </div>
    </div>
    <!-- 底部导航栏 -->
    <BottomNavigation :currentRoute="$route.path" />
  </div>
</template>
<script>
import axios from 'axios'
import { Toast } from 'vant'
import BottomNavigation from '@/components/BottomNavigation.vue'
import { API_ENDPOINTS } from '@/config/api'

// 后台未配置 qq 时的兜底客服，保证首页始终能看到联系方式
const DEFAULT_KEFU_CONTACT = '3474659718'

export default {
  components: {
    BottomNavigation
  },
  data() {
    return {
      userInfo: {
        username: '',
        points: 0,
        balance: 0
      },
      showKefuNotice: false,  // 是否显示客服QQ公告
      showKefu: false,        // 是否显示客服按钮
      kefuQQ: '',             // 客服QQ
      gxyAddedCount: 100      // 展示用累计添加数
    };
  },
  computed: {
    kefuText() {
      const raw = (this.kefuQQ || '').trim();
      return /^\d{5,12}$/.test(raw) ? `客服QQ：${raw}` : raw;
    }
  },
  async mounted() {
    await this.getUserInfo();
    await this.getKefuConfig();
    this.getAddedCount();
  },
  methods: {
    showToast(message) {
      Toast(message);
    },
    async getUserInfo() {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          this.$router.push('/lanhu_yonghudenglu');
          return;
        }
        
        const res = await axios.get(API_ENDPOINTS.USER.INFO, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        
        if (res.data.code === 0) {
          this.userInfo = {
            username: res.data.data.username || '用户',
            points: res.data.data.points || 0,
            balance: res.data.data.balance || 0
          };
        } else {
          console.error('获取用户信息失败:', res.data.message);
          // 如果token无效，跳转到登录页
          if (res.data.code === 401) {
            localStorage.removeItem('token');
            this.$router.push('/lanhu_yonghudenglu');
          }
        }
      } catch (error) {
        console.error('获取用户信息出错:', error);
        // 网络错误或其他错误，可能需要重新登录
        if (error.response && error.response.status === 401) {
          localStorage.removeItem('token');
          this.$router.push('/lanhu_yonghudenglu');
        }
      }
    },
    
    // 添加公学芸
    async addGongXueYun() {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          this.$router.push('/lanhu_yonghudenglu');
          return;
        }
        
        // 跳转到账号管理页面进行添加
        this.$router.push('/lanhu_tianjiazhanghao');
      } catch (error) {
        console.error('跳转失败:', error);
        this.$toast('跳转失败，请重试');
      }
    },

    // 添加校友帮
    async addXiaoYouBang() {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          this.$router.push('/lanhu_yonghudenglu');
          return;
        }

        this.$router.push('/lanhu_tianjiazhanghao?platform=xyb');
      } catch (error) {
        console.error('跳转失败:', error);
        this.$toast('跳转失败，请重试');
      }
    },
    
    // 展示用累计添加数(后端从100起, 每成功添加一人+1)
    async getAddedCount() {
      try {
        const res = await axios.get(API_ENDPOINTS.GXY.GET_ADDED_COUNT);
        const value = res.data && res.data.code === 0 && res.data.data
          ? Number(res.data.data.count)
          : NaN;
        if (Number.isFinite(value) && value >= 0) {
          this.gxyAddedCount = value;
        }
      } catch (error) {
        console.error('获取添加计数失败:', error);
      }
    },

    // 获取客服配置
    async getKefuConfig() {
      let contact = '';
      try {
        const token = localStorage.getItem('token');
        if (!token) return;

        const res = await axios.get(API_ENDPOINTS.SETTING.GET_SETTING, {
          headers: {
            'Authorization': `Bearer ${token}`
          },
          params: {
            key: 'qq'  // 修改为正确的key
          }
        });

        if (res.data && res.data.code === 0 && res.data.data) {
          contact = String(res.data.data).trim();
        }
      } catch (error) {
        console.error('获取客服配置失败:', error);
      }
      // 即使后台没配或请求失败，也把兜底联系方式留在首页
      this.kefuQQ = contact || DEFAULT_KEFU_CONTACT;
      this.showKefu = true;
      this.showKefuNotice = true;
    },

    // 联系客服
    contactKefu() {
      const raw = (this.kefuQQ || '').trim();
      if (/^\d{5,12}$/.test(raw)) {
        window.open(`https://wpa.qq.com/msgrd?v=3&uin=${raw}&site=qq&menu=yes`);
      } else if (raw) {
        Toast(raw);
      }
    },
    // 跳转AIGC工具
    openAigc() {
      window.open('https://aiguogao.com/', '_blank');
    }
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />

<style>
.multi-gxy-tip {
  margin: 10px 16px;
  padding: 10px 12px;
  border-radius: 10px;
  background: rgba(0, 203, 106, 0.10);
  color: #152C07;
  display: flex;
  flex-direction: column;
  gap: 3px;
  line-height: 1.45;
}
.multi-gxy-tip strong { font-size: 14px; color: #00a85a; }
.multi-gxy-tip span { font-size: 12px; color: #58705d; }

.added-count {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: 10px 16px 0;
}
.added-count-label { font-size: 13px; color: #58705d; line-height: 1.2; }
.added-count-value { font-size: 18px; font-weight: 700; color: #00a85a; line-height: 1.2; }
.promo-red { color: #ff3b30; font-weight: 700; }
.promo-red-count { font-size: 15px; margin-left: 6px; }
.multi-gxy-tip .promo-red { font-size: 13px; }
</style>
